import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames/bind';
import find from 'lodash/find';
import get from 'lodash/get';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ProductConstants from '../../common/ProductConstants';
import { selectMessagesWrapper } from '../../selectors/PdpNameSpaceSelector';
import * as styles from './ProductOptions.css';

const SecondaryDimension = (props) => {
    const featureFlags = useSelector((state) => state.context.featureFlags);
    const { fromMiniPDP, dimension, option } = props;
    const messages = useSelector((state) => selectMessagesWrapper(fromMiniPDP)(state));
    const cx = classNames.bind(styles);
    let dimensionText = '';
    let dimensionMessage = '';
    const selectedColor = find(dimension.options, { value: option });
    /* istanbul ignore else */
    if (dimension.id === 'COLOR' && option && selectedColor) {
        dimensionText = get(selectedColor, 'name', '');
        let availabilityMessage = get(selectedColor, 'availabilityMessage', '');
        const oosTextIndex =
            availabilityMessage &&
            ProductConstants.OUTOFSTOCK &&
            availabilityMessage.indexOf(ProductConstants.OUTOFSTOCK) - 2;
        // if availabilityMessage contains OOS, style OOS differently
        if (oosTextIndex > -1) {
            availabilityMessage = availabilityMessage && availabilityMessage.slice(0, oosTextIndex);
        }
        dimensionMessage = availabilityMessage && (
            <div
                className={`${cx('secondaryDimensionSpan', props.hasMounted ? 's' : 'c')} ${dt([
                    fromMiniPDP ? 'mt-0' : 'my-0',
                ])}`}
                aria-label={dimensionText.toLowerCase()}
                data-automation-id={dimensionText.toLowerCase()}
            >
                <span className={dt(['font-open-sans-semibold', 'text-sm', 'text-black'])}>
                    Color
                </span>
                {oosTextIndex > -1 ? (
                    <>
                        <span className={dt(['text-gray-60'])}>{` - `}</span>
                        <span className={dt(['line-through', 'text-sm', 'text-gray-60'])}>
                            {availabilityMessage}
                        </span>
                    </>
                ) : (
                    <span className={dt(['text-sm', 'text-gray-60'])}>
                        {` - ${availabilityMessage}`}{' '}
                    </span>
                )}
            </div>
        );
    } else if (dimension.id === 'COLOR') {
        dimensionMessage = (
            <div
                className={`${cx(
                    'secondaryDimensionSpan',
                    'noColorSelected',
                    props.hasMounted ? 's' : 'c'
                )} ${dt([fromMiniPDP ? 'mt-0' : 'my-0'])}`}
            >
                <span
                    className={dt([
                        'font-open-sans-semibold',
                        featureFlags?.enableErrorSizing &&
                        messages?.COLOR &&
                        messages?.COLOR?.length > 0
                            ? ''
                            : 'text-black',
                    ])}
                >
                    Color
                </span>
                {fromMiniPDP &&
                    !featureFlags?.enableErrorSizing &&
                    (!messages?.COLOR || messages?.COLOR?.length < 0) && (
                        <>
                            <span className={dt(['text-black'])}> - </span>
                            <span className={dt(['font-open-sans-regular', 'text-urgency-border'])}>
                                {ProductConstants.MINI_PDP_SELECT_A_COLOR}
                            </span>
                        </>
                    )}
            </div>
        );
    }
    return dimensionMessage;
};

export default SecondaryDimension;
